import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';
import logo from '../assets/logo.svg';
import logoEng from '../assets/logoeng.svg';

function Navigation({ language, onLanguageChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const texts = {
    en: {
      home: 'Home',
      programs: 'Programs',
      schedule: 'Schedule',
      people: 'People',
      research: 'Network',
      submit: 'Submit',
      contact: 'Contact'
    },
    zh: {
      home: '首页',
      programs: '项目',
      schedule: '日程',
      people: '团队',
      research: '网络',
      submit: '投稿',
      contact: '联系'
    }
  };

  const currentTexts = texts[language];
  const menuItems = [
    { id: 'home', label: currentTexts.home, path: '/' },
    { id: 'programs', label: currentTexts.programs, path: '/programs' },
    { id: 'schedule', label: currentTexts.schedule, path: '/scheduletext' },
    { id: 'people', label: currentTexts.people, path: '/people' },
    { id: 'network', label: currentTexts.research, path: '/network' },
    { id: 'contact', label: currentTexts.contact, path: '/contact' }
  ];

  return (
    <nav className={`main-navigation ${isOpen ? 'open' : ''}`}>
      <div className="nav-container">
        <div className="nav-brand">
          <img src={language === 'en' ? logoEng : logo} alt="VGARC PKU Logo" className="brand-logo" />
        </div>

        <button
          type="button"
          className={`nav-toggle ${isOpen ? 'active' : ''}`}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <div className="nav-menu" onClick={() => setIsOpen(false)}>
          {menuItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) =>
                `nav-item ${item.id === 'schedule' ? 'nav-feature' : ''} ${isActive ? 'active' : ''}`
              }
            >
              <span className="nav-text">{item.label}</span>
              <div className="nav-glow"></div>
            </NavLink>
          ))}
          <NavLink
            to="/submit"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="nav-text">{currentTexts.submit}</span>
            <div className="nav-glow"></div>
          </NavLink>

          <div className="mobile-language-toggle">
            <button
              className={language === 'en' ? 'active' : ''}
              onClick={() => onLanguageChange('en')}
              aria-label="Switch to English"
            >
              <span>EN</span>
            </button>
            <button
              className={language === 'zh' ? 'active' : ''}
              onClick={() => onLanguageChange('zh')}
              aria-label="Switch to Chinese"
            >
              <span>中文</span>
            </button>
          </div>
        </div>

        <div className="nav-controls">
          <div className="language-toggle">
            <button
              className={language === 'en' ? 'active' : ''}
              onClick={() => onLanguageChange('en')}
              aria-label="Switch to English"
            >
              <span>EN</span>
            </button>
            <button
              className={language === 'zh' ? 'active' : ''}
              onClick={() => onLanguageChange('zh')}
              aria-label="Switch to Chinese"
            >
              <span>中文</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
